module.exports = __webpack_public_path__ + "img/telescope.b6a8d036.webp";